import React from 'react';

export const Diamond = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.41421L16.5858 9L9 16.5858L1.41421 9L9 1.41421Z"
      stroke={color ?? '#626262'}
      strokeWidth="2"
    />
  </svg>
);
